import { LoketEmployment, LoketEmploymentResource } from './LoketEmployment'

export const transformToLoketEmployment = (resource: LoketEmploymentResource): LoketEmployment => ({
    id: resource.id,
    start: new Date(resource.start),
    end: resource.end ? new Date(resource.end) : undefined,
})
